import { render } from "./DropdownAutocompleteBase.vue?vue&type=template&id=1390e461&scoped=true&ts=true"
import script from "./DropdownAutocompleteBase.vue?vue&type=script&lang=ts"
export * from "./DropdownAutocompleteBase.vue?vue&type=script&lang=ts"

import "./DropdownAutocompleteBase.vue?vue&type=style&index=0&id=1390e461&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/Momentum/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1390e461"]])

export default __exports__